import {
  ADD_PRODUCT,
  ADD_PRODUCT_COMPLETED,
  ADD_PRODUCT_FAILED,
  ADJUST_PRODUCT,
  ADJUST_PRODUCT_COMPLETED,
  ADJUST_PRODUCT_FAILED,
  CHANGE_PRODUCT_SALEPRICE,
  CHANGE_PRODUCT_SALEPRICE_COMPLETED,
  CHANGE_PRODUCT_SALEPRICE_FAILED,
  GET_PRODUCT,
  GET_PRODUCT_COMPLETED,
  GET_PRODUCT_FAILED,
  GET_PRODUCT_TO_REORDER_LIST,
  GET_PRODUCT_TO_REORDER_LIST_COMPLETED,
  GET_PRODUCT_TO_REORDER_LIST_FAILED,
  GET_PRODUCTS,
  GET_PRODUCTS_COMPLETED,
  GET_PRODUCTS_FAILED,
  RECEIVE_PRODUCT,
  RECEIVE_PRODUCT_COMPLETED,
  RECEIVE_PRODUCT_FAILED,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_COMPLETED,
  UPDATE_PRODUCT_FAILED,
  GENERATE_BARCODE,
  GENERATE_BARCODE_COMPLETED,
  GENERATE_BARCODE_FAILED,
  SEARCH_PRODUCTS,
  SEARCH_PRODUCTS_COMPLETED,
  SEARCH_PRODUCTS_FAILED,
  GET_PRODUCT_STOCKS,
  GET_PRODUCT_STOCKS_COMPLETED,
  GET_PRODUCT_STOCKS_FAILED,
  SEARCH_PRODUCT_STOCKS,
  SEARCH_PRODUCT_STOCKS_COMPLETED,
  SEARCH_PRODUCT_STOCKS_FAILED,
  SHOW_DELETE_PRODUCT_MODAL,
  HIDE_DELETE_PRODUCT_MODAL,
  DELETE_PRODUCT,
  DELETE_PRODUCT_COMPLETED,
  DELETE_PRODUCT_FAILED,
  GET_PRODUCT_STOCK,
  GET_PRODUCT_STOCK_COMPLETED,
  GET_PRODUCT_STOCK_FAILED,
  SEARCH_PRODUCT_HISTORY,
  SEARCH_PRODUCT_HISTORY_COMPLETED,
  SEARCH_PRODUCT_HISTORY_FAILED,
  SEARCH_PRODUCT_STOCK_BATCHES,
  SEARCH_PRODUCT_STOCK_BATCHES_COMPLETED,
  SEARCH_PRODUCT_STOCK_BATCHES_FAILED,
  GET_PRODUCT_STOCK_BATCH,
  GET_PRODUCT_STOCK_BATCH_COMPLETED,
  GET_PRODUCT_STOCK_BATCH_FAILED,
  CORRECT_RECEIVED_PRODUCT,
  CORRECT_RECEIVED_PRODUCT_COMPLETED,
  CORRECT_RECEIVED_PRODUCT_FAILED,
  SET_SUPPLIER_TO_REORDER,
  SEARCH_PRODUCTS_SOLD, SEARCH_PRODUCTS_SOLD_COMPLETED, SEARCH_PRODUCTS_SOLD_FAILED
} from './actions';
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  productsLoading: false,
  products: [],
  productsError: null,
  productLoading: false,
  product: null,
  productError: null,
  productToReorderListLoading: false,
  productToReorderList: [],
  productToReorderListError: null,
  productToReorderLoading: false,
  productToReorder: null,
  productToReorderError: null,
  productAdjustmentsLoading: false,
  productAdjustments: [],
  productAdjustmentsError: null,
  addingProduct: false,
  adjustingProduct: false,
  updatingProduct: false,
  changingProductSalePrice: false,
  generatingBarcode: false,
  generatedBarcode: null,
  generateBarcodeError: null,
  productsSearch: searchDefault,
  gettingProductStocks: false,
  productStocks: [],
  stocksSearch: searchDefault,
  deleteProductModalVisible: false,
  productToDelete: null,
  productDeleting: false,
  gettingProductStock: false,
  productStock: null,
  productHistorySearch: searchDefault,
  receivingProduct: false,
  stockBatchesSearch: searchDefault,
  gettingProductStockBatch: false,
  productStockBatch: null,
  correctingReceivedProduct: false,
  enterSoldProducts: false,
  supplierToReorderId: '',
  productsSoldSearch: searchDefault,
};

const productReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_PRODUCTS: return handleSearch(state, 'productsSearch', action.payload);
    case SEARCH_PRODUCTS_COMPLETED: return handleSearchCompleted(state, 'productsSearch', action.payload);
    case SEARCH_PRODUCTS_FAILED: return handleSearchFailed(state, 'productsSearch', action.payload);
    case GET_PRODUCTS: {
      return {
        ...state,
        productsLoading: true,
        products: [],
        productsError: null,
      };
    }
    case GET_PRODUCTS_COMPLETED: {
      return {
        ...state,
        productsLoading: false,
        products: action.payload.data,
      };
    }
    case GET_PRODUCTS_FAILED: {
      return {
        ...state,
        productsLoading: false,
        productsError: action.payload,
      };
    }
    case GET_PRODUCT: {
      return {
        ...state,
        productLoading: true,
        product: null,
        productError: null,
      };
    }
    case GET_PRODUCT_COMPLETED: {
      return {
        ...state,
        productLoading: false,
        product: action.payload,
      };
    }
    case GET_PRODUCT_FAILED: {
      return {
        ...state,
        productLoading: false,
        productError: action.payload,
      };
    }
    case GET_PRODUCT_TO_REORDER_LIST: {
      return {
        ...state,
        productToReorderListLoading: true,
        productToReorderList: [],
        productToReorderListError: null,
      };
    }
    case GET_PRODUCT_TO_REORDER_LIST_COMPLETED: {
      return {
        ...state,
        productToReorderListLoading: false,
        productToReorderList: action.payload.data,
      };
    }
    case GET_PRODUCT_TO_REORDER_LIST_FAILED: {
      return {
        ...state,
        productToReorderListLoading: false,
        productToReorderListError: action.payload,
      };
    }
    case ADD_PRODUCT: {
      return {
        ...state,
        addingProduct: true,
      };
    }
    case ADD_PRODUCT_COMPLETED: {
      return {
        ...state,
        addingProduct: false,
      };
    }
    case ADD_PRODUCT_FAILED: {
      return {
        ...state,
        addingProduct: false,
      };
    }
    case CHANGE_PRODUCT_SALEPRICE: {
      return {
        ...state,
        changingProductSalePrice: true,
      };
    }
    case CHANGE_PRODUCT_SALEPRICE_COMPLETED: {
      return {
        ...state,
        changingProductSalePrice: false,
      };
    }
    case CHANGE_PRODUCT_SALEPRICE_FAILED: {
      return {
        ...state,
        changingProductSalePrice: false,
      };
    }
    case RECEIVE_PRODUCT: {
      return {
        ...state,
        receivingProduct: true,
      };
    }
    case RECEIVE_PRODUCT_COMPLETED: {
      return {
        ...state,
        receivingProduct: false,
      };
    }
    case RECEIVE_PRODUCT_FAILED: {
      return {
        ...state,
        receivingProduct: false,
      };
    }
    case ADJUST_PRODUCT: {
      return {
        ...state,
        adjustingProduct: true,
      };
    }
    case ADJUST_PRODUCT_COMPLETED: {
      return {
        ...state,
        adjustingProduct: false,
      };
    }
    case ADJUST_PRODUCT_FAILED: {
      return {
        ...state,
        adjustingProduct: false,
      };
    }
    case UPDATE_PRODUCT: {
      return {
        ...state,
        updatingProduct: true,
      };
    }
    case UPDATE_PRODUCT_COMPLETED: {
      return {
        ...state,
        updatingProduct: false,
      };
    }
    case UPDATE_PRODUCT_FAILED: {
      return {
        ...state,
        updatingProduct: false,
      };
    }
    case GENERATE_BARCODE: {
      return {
        ...state,
        generatingBarcode: true,
        generatedBarcode: null,
        generateBarcodeError: null,
      };
    }
    case GENERATE_BARCODE_COMPLETED: {
      return {
        ...state,
        generatingBarcode: false,
        generatedBarcode: action.payload.barcode,
      };
    }
    case GENERATE_BARCODE_FAILED: {
      return {
        ...state,
        generatingBarcode: false,
        generateBarcodeError: action.payload,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    case GET_PRODUCT_STOCKS: {
      return {
        ...state,
        gettingProductStocks: true,
        productStocks: [],
      };
    }
    case GET_PRODUCT_STOCKS_COMPLETED: {
      return {
        ...state,
        gettingProductStocks: false,
        productStocks: action.payload.data,
      };
    }
    case GET_PRODUCT_STOCKS_FAILED: {
      return {
        ...state,
        gettingProductStocks: false,
      };
    }
    case GET_PRODUCT_STOCK: {
      return {
        ...state,
        gettingProductStock: true,
        productStock: null,
      };
    }
    case GET_PRODUCT_STOCK_COMPLETED: {
      return {
        ...state,
        gettingProductStock: false,
        productStock: action.payload,
      };
    }
    case GET_PRODUCT_STOCK_FAILED: {
      return {
        ...state,
        gettingProductStock: false,
      };
    }
    case SEARCH_PRODUCT_STOCKS: return handleSearch(state, 'stocksSearch', action.payload);
    case SEARCH_PRODUCT_STOCKS_COMPLETED: return handleSearchCompleted(state, 'stocksSearch', action.payload);
    case SEARCH_PRODUCT_STOCKS_FAILED: return handleSearchFailed(state, 'stocksSearch', action.payload);
    case SHOW_DELETE_PRODUCT_MODAL: {
      return {
        ...state,
        deleteProductModalVisible: true,
        productToDelete: action.payload,
      };
    }
    case HIDE_DELETE_PRODUCT_MODAL: {
      return {
        ...state,
        deleteProductModalVisible: false,
        productToDelete: null,
      };
    }
    case DELETE_PRODUCT: {
      return {
        ...state,
        productDeleting: true,
      };
    }
    case DELETE_PRODUCT_COMPLETED: {
      return {
        ...state,
        productDeleting: false,
      };
    }
    case DELETE_PRODUCT_FAILED: {
      return {
        ...state,
        productDeleting: false,
      };
    }
    case SEARCH_PRODUCT_HISTORY: return handleSearch(state, 'productHistorySearch', action.payload);
    case SEARCH_PRODUCT_HISTORY_COMPLETED: return handleSearchCompleted(state, 'productHistorySearch', action.payload);
    case SEARCH_PRODUCT_HISTORY_FAILED: return handleSearchFailed(state, 'productHistorySearch', action.payload);
    case SEARCH_PRODUCT_STOCK_BATCHES: return handleSearch(state, 'stockBatchesSearch', action.payload);
    case SEARCH_PRODUCT_STOCK_BATCHES_COMPLETED: return handleSearchCompleted(state, 'stockBatchesSearch', action.payload);
    case SEARCH_PRODUCT_STOCK_BATCHES_FAILED: return handleSearchFailed(state, 'stockBatchesSearch', action.payload);
    case GET_PRODUCT_STOCK_BATCH: {
      return {
        ...state,
        gettingProductStockBatch: true,
        productStockBatch: null,
      };
    }
    case GET_PRODUCT_STOCK_BATCH_COMPLETED: {
      return {
        ...state,
        gettingProductStockBatch: false,
        productStockBatch: action.payload,
      };
    }
    case GET_PRODUCT_STOCK_BATCH_FAILED: {
      return {
        ...state,
        gettingProductStockBatch: false,
      };
    }
    case CORRECT_RECEIVED_PRODUCT: {
      return {
        ...state,
        correctingReceivedProduct: true,
      };
    }
    case CORRECT_RECEIVED_PRODUCT_COMPLETED: {
      return {
        ...state,
        correctingReceivedProduct: false,
      };
    }
    case CORRECT_RECEIVED_PRODUCT_FAILED: {
      return {
        ...state,
        correctingReceivedProduct: false,
      };
    }
    case SET_SUPPLIER_TO_REORDER: {
      const {supplierId} = action.payload;
      return {
        ...state,
        supplierToReorderId: supplierId
      };
    }
    case SEARCH_PRODUCTS_SOLD: return handleSearch(state, 'productsSoldSearch', action.payload);
    case SEARCH_PRODUCTS_SOLD_COMPLETED: return handleSearchCompleted(state, 'productsSoldSearch', action.payload);
    case SEARCH_PRODUCTS_SOLD_FAILED: return handleSearchFailed(state, 'productsSoldSearch', action.payload);
    default:
      return state;
  }
};

export default productReducer;



// WEBPACK FOOTER //
// ./src/Product/reducer.js